import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import { BootstrapVue } from "bootstrap-vue";
import axios from "axios";
import VueAxios from "vue-axios";
import store from "./store";
import DefaultLayout from "@/layouts/Default";
import ApiService from "@/api";
import i18n from "@/plugins/i18n";
import SlideUpDown from "vue-slide-up-down";
import { extend, localize } from "vee-validate";
import VueMobileDetection from "vue-mobile-detection";
import VueAnalytics from "vue-analytics";
import vueHeadful from "vue-headful";
import VueCookies from "vue-cookies";
import {
  required,
  email,
  required_if,
  length,
  min_value,
  numeric,
  max
} from "vee-validate/dist/rules";
import VueSocialSharing from "vue-social-sharing";
import { GOOGLE_ANALYTICS } from "./api/config";
import { firestorePlugin } from "vuefire";
import Vlf from "vlf";
import localforage from "localforage";
import en from "vee-validate/dist/locale/en.json";
import fr from "vee-validate/dist/locale/fr.json";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "vue2-datepicker/index.css";
import "@/assets/css/main.css";
import "@/assets/css/styles.css";
import "vue-cool-lightbox/dist/vue-cool-lightbox.min.css";
import "./registerServiceWorker";
import "./firebase/init";
// Add the required rule
extend("length", {
  ...length
});
extend("required", {
  ...required
});
extend("required_if", {
  ...required_if
});
extend("email", {
  ...email
});
extend("min_value", {
  ...min_value
});
extend("numeric", {
  ...numeric
});
extend("max", {
  ...max
});

const isChecked = value => value;
extend("checked", isChecked);
localize({
  en,
  fr
});
Vue.component("vue-headful", vueHeadful);
Vue.use(VueCookies);
Vue.use(Vlf, localforage);
Vue.use(VueMobileDetection);
Vue.use(VueSocialSharing);
Vue.component("default-layout", DefaultLayout);
Vue.use(VueAxios, axios);
Vue.component("slide-up-down", SlideUpDown);
// Install BootstrapVue
Vue.use(BootstrapVue);
// Optionally install the BootstrapVue icon components plugin
Vue.config.productionTip = false;
ApiService.init();
Vue.use(VueAnalytics, {
  id: GOOGLE_ANALYTICS,
  router
});
Vue.use(firestorePlugin);
Vue.$cookies.config("1d");
new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount("#app");

console.log(
  "✅ Atlantica Parc APP LOADED — build: 9babe8c1 — " + new Date().toISOString()
);
